import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button"]

  toggle() {
    const isOpen = this.element.classList.toggle("menu-open");
    if (this.hasButtonTarget) {
      this.buttonTarget.setAttribute("aria-expanded", isOpen);
    }
  }
}
